import { getPhoneCountryOptions } from "@fluenceur/types";
const PRIORITY_COUNTRIES = ["FR", "US", "GB", "CA", "DE", "ES", "IT", "NL", "BE", "PT"];
const PLACEHOLDERS = {
    FR: "06 12 34 56 78",
    US: "(555) 123-4567",
    GB: "07700 900123",
    CA: "(555) 123-4567",
    DE: "0151 12345678",
    ES: "612 34 56 78",
    IT: "312 345 6789",
    NL: "06 12345678",
    BE: "0470 12 34 56",
    PT: "912 345 678",
};
/** One list per language: naming ~250 regions with Intl.DisplayNames is not free. */
const byLocale = new Map();
export const getCountryData = (locale = "en") => {
    const cached = byLocale.get(locale);
    if (cached)
        return cached;
    const data = buildCountryData(locale);
    byLocale.set(locale, data);
    return data;
};
const buildCountryData = (locale) => {
    let collator;
    try {
        collator = new Intl.Collator(locale);
    }
    catch {
        collator = new Intl.Collator("en");
    }
    const countries = getPhoneCountryOptions(locale).map((country) => ({
        ...country,
        placeholder: PLACEHOLDERS[country.value],
    }));
    const priority = PRIORITY_COUNTRIES.map((code) => countries.find((country) => country.value === code))
        .filter((country) => country !== undefined);
    const other = countries.filter((country) => !PRIORITY_COUNTRIES.includes(country.value))
        .sort((a, b) => collator.compare(a.label, b.label));
    return [...priority, ...other];
};
export const DEFAULT_COUNTRY = "FR";
